<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-17 11:44:11
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-21 17:18:32
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div
		class="commercial-high main-content-padding"
		v-scroll-lazy-load="{
			loadData,
			distance: 100,
			delay: 1000,
			callback: fn => this.$once('hook:beforeDestroy', () => fn()),
		}"
	>
		<Panel :contentPaddingTop="12" :class="{ comingSoon: $isPlatOr(platformId, ['Sp']) }">
			<platform-tab @change="handleClick" :platformId="platformId"></platform-tab>
			<template v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
				<div v-show="showPlatformContent">
					<div class="promotion-entrance flex flex-align-center pointer" @click="goPromotion()">
						<img class="promotion-img mr-4" src="@/assets/public/promotion-icon.png" alt="" />
						<span class="fz-12 promotion-text">我的推广商品</span>
					</div>
					<div class="commercial-content">
						<!--搜索区域-->
						<search :key="refreshKey" @refresh="onRefresh" ref="search" :platformId="platformId" @clear="onClear" />
						<!--商品列表-->
						<goods-list
							v-if="hasData"
							:lazyState="lazyState"
							:platformId="platformId"
							:skeletonCount="skeletonScreenCount"
							:list="goodsList"
							class="mt-24 goods-list-content"
						></goods-list>
						<template v-if="goodsList.length">
							<div
								v-show="!noMore"
								class="loading-text"
								v-loading="loading"
								element-loading-text="拼命加载中"
								element-loading-spinner="el-icon-loading"
							></div>
							<div class="no-more fz-12" v-if="noMore">—— 没有更多了 ——</div>
						</template>
						<Empty v-if="!hasData"></Empty>
					</div>
				</div>
			</template>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Sp']) }" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>

			<el-backtop class="back-top" target=".commercial-high" :visibility-height="1200" :bottom="200" :right="40"> </el-backtop>
		</Panel>
	</div>
</template>
<script>
import search from './components/search/index.vue';
import goodsList from './components/goodsList/index.vue';
import { productCommonList } from '@/api/shopManage';
import emptyPage from '@/views/common/empty/index.vue';

import debounce from 'lodash/debounce';
import { platformMixin } from '@rd/rd-ui';
export default {
	components: {
		search,
		goodsList,
		emptyPage,
	},
	mixins: [platformMixin],
	data() {
		return {
			goodsList: [],
			lazyState: false,
			loading: false,
			backState: false,
			totalCount: 0,
			searchParams: {
				outerProductName: '',
				cateId: [],
				page_index: 1,
				page_size: 20,
				commissionRate: '',
				commissionType: 0,
				shopScore: '',
				serviceFeeRate: '',
				talentCommission: '',
				sortField: 'orderNum',
				sortType: 'desc',
			},
			hasData: true,
			skeletonScreenCount: 20,
			refreshKey: false,
		};
	},
	computed: {
		noMore() {
			return this.goodsList.length >= this.totalCount && this.goodsList.length;
		},
		disabled() {
			return this.loading || this.noMore;
		},
	},
	methods: {
		initParams() {
			this.goodsList = [];
			(this.searchParams = {
				outerProductName: '',
				auditStatus: '0',
				cateId: [],
				page_index: 1,
				page_size: 20,
				commissionRate: '',
				commissionType: 0,
				outerShopScore: '',
				serviceFeeRate: '',
				talentCommission: '',
				sortField: 'orderNum',
				sortType: 'desc',
				appType: '',
			}),
				(this.skeletonScreenCount = 20);
		},
		handleClick(val) {
			this.refreshKey = !this.refreshKey;
			this.initParams();
			this.platformId = val;
			this.getList();
		},
		onClear() {
			this.refreshKey = !this.refreshKey;
			this.initParams();
			this.getList();
		},
		/**
		 * 如果在大屏幕撑不满上拉加载的条件，则在请求一次接口，直到撑满上拉加载的条件
		 */
		async perfuse() {
			let hasGoodTable = document.querySelector('.goods-table');
			let hasCommercialHigh = document.querySelector('.commercial-high');
			let hasElement = hasGoodTable && hasCommercialHigh;
			if (hasElement) {
				if (hasGoodTable.clientHeight < hasCommercialHigh.clientHeight && !this.noMore) {
					++this.searchParams.page_index;
					this.skeletonScreenCount = Number(this.skeletonScreenCount) * Number(this.searchParams.page);
					this.getList();
				}
			}
		},
		async getList() {
			try {
				if (!this.showPlatformContent) return;
				this.loading = true;
				if (this.searchParams.page_index === 1) this.lazyState = true;
				const { data, code } = await productCommonList({ platformId: this.platformId, ...this.searchParams });
				if (code !== 0) return;
				this.totalCount = data.total;
				this.goodsList = [...this.goodsList, ...data.list];
				this.$nextTick(() => {
					this.perfuse();
				});
			} finally {
				this.loading = false;
				this.lazyState = false;
				this.hasData = Boolean(this.goodsList.length);
			}
		},
		loadData() {
			if (this.noMore) {
				return;
			}
			++this.searchParams.page_index;
			this.getList();
		},
		goPromotion() {
			this.$router.push({ path: `/shopManage/commercial/promoteList?platformId=${this.platformId}` });
		},
		onRefresh: debounce(function (obj) {
			this.goodsList = [];
			if (obj.appType) {
				obj.appType = obj.appType.charAt(obj.appType.length - 1);
			}
			obj.auditStatus = obj.auditStatus ? obj.auditStatus : '0';
			this.searchParams = obj;
			this.searchParams.page_index = 1;
			this.getList();
		}, 200),
	},

	mounted() {
		this.getList();
	},
};
</script>
<style scoped lang="less">
.commercial-high {
	height: 100%;
	overflow: auto;
	.commercial-content {
		margin: 0 auto;
		width: 1212px;
		padding-bottom: 230px;
	}
	.loading-text,
	.no-more {
		margin-top: 60px;
		color: @color-gy6;
	}
	.back-top {
		width: 40px;
		height: 40px;
		color: @color-primary;
	}
	.no-more {
		color: @color-gy7;
		text-align: center;
		line-height: 20px;
	}
	.promotion-entrance {
		position: absolute;
		padding: 6px 12px 6px 12px;
		border-radius: 30px;
		right: 24px;
		top: 14px;
		background: @color-b1;
		.promotion-img {
			width: 11px;
			height: 12px;
		}
		.promotion-text {
			line-height: 18px;
			font-family: 'PingFangSC-Regular';
			color: @color-gy9;
		}
	}
}
.main-content-padding {
	display: flex;
	flex: 1;
	flex-direction: column;
	min-height: calc(100%-24px);
}
</style>
